import { render, staticRenderFns } from "./StatisticsReport.vue?vue&type=template&id=a7cf9a10&scoped=true&"
import script from "./StatisticsReport.vue?vue&type=script&lang=js&"
export * from "./StatisticsReport.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsReport.vue?vue&type=style&index=0&id=a7cf9a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cf9a10",
  null
  
)

export default component.exports